<div class="basic-components">
    <h2>{{title}}</h2>
    <h6>
        Acceso a página no autorizado para el usuario.
    </h6>
    <img class="image-pagenotfound" src="assets/images/PageNotFound.png" />
</div>
